// Firebase configuration - uses .env (Create React App embeds these at start time)
const env = process.env;
export const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY,
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.REACT_APP_FIREBASE_APP_ID
};

if (process.env.NODE_ENV === 'development') {
  // Helps confirm .env was picked up after npm start
  // eslint-disable-next-line no-console
  console.info('[Firebase]', firebaseConfig.projectId || '(missing REACT_APP_FIREBASE_PROJECT_ID - restart npm start)');
}
